/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type CodeCell_ClaimCodeFragment = { __typename: 'MultiClaimCodeDocument', id: string, code: string };

export const CodeCell_ClaimCodeFragmentDoc = gql`
    fragment CodeCell_claimCode on MultiClaimCodeDocument {
  id
  code
}
    `;